import baseAPI from '@/api/base';
import { LoginCredentals, LoginOAuthCredentals, SignupCredentals, SignupOAuthCredentals } from '@/dtos/auth.dto';
import {
  EDIT_USER_URL,
  FORGOT_PASSWORD_URL,
  LOGIN_OAUTH_URL,
  LOGIN_URL,
  REQUEST_EMAIL_VERIFICATION,
  REQUEST_SET_PASSWORD_AND_VERIFY_URL,
  RESET_PASSWORD,
  RESET_PASSWORD_AUTHED_URL,
  SET_PASSWORD_AND_VERIFY_URL,
  SIGNUP_OAUTH_URL,
  SIGNUP_URL,
  VERIFY_EMAIL_URL,
} from '@/utils/urls';
import { CLIENT_APP } from '@/utils/const';
import { AxiosResponse } from 'axios';
import {
  EditUser,
  ForgotPassword,
  GetUser,
  ResetPassword,
  ResetPasswordObj,
  SetPasswordPasswordAndVerifyObj,
} from '@/dtos/user.dto';

class Auth {
  // Both sign-ins say which app they're for: the API lets people in only to
  // the apps their organization has.
  static login = async (
    loginCredentals: LoginCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(LOGIN_URL, {
      ...loginCredentals,
      app: CLIENT_APP,
    });
    console.log('response', response);
    return response;
  };

  static loginOAuth = async (
    loginOAuthCredentals: LoginOAuthCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(LOGIN_OAUTH_URL, {
      ...loginOAuthCredentals,
      app: CLIENT_APP,
    });
    console.log('response', response);
    return response;
  };

  static signup = async (
    registrationCredentals: SignupCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(SIGNUP_URL, {
      ...registrationCredentals,
    });
    console.log('response', response);
    return response;
  };

  static signupOAuth = async (
    registrationOAuthCredentals: SignupOAuthCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(SIGNUP_OAUTH_URL, {
      ...registrationOAuthCredentals,
    });
    console.log('response', response);
    return response;
  };

  static forgotPassword = async (
    forgotPassword: ForgotPassword
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(FORGOT_PASSWORD_URL, {
      ...forgotPassword,
    });
    return response;
  };

  static resetPassword = async (
    resetPassword: ResetPasswordObj
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      `${RESET_PASSWORD}/${resetPassword.token}`,
      {
        ...resetPassword.resetPasswordObj,
      }
    );
    return response;
  };

  static resetPasswordAuthed = async (
    resetPassword: ResetPassword
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      RESET_PASSWORD_AUTHED_URL,
      {
        ...resetPassword,
      }
    );
    return response;
  };

  static setPasswordAndVerify = async (
    setPasswordPasswordAndVerifyObj: SetPasswordPasswordAndVerifyObj
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      `${SET_PASSWORD_AND_VERIFY_URL}/${setPasswordPasswordAndVerifyObj.token}`,
      {
        ...setPasswordPasswordAndVerifyObj.setPasswordObj,
      }
    );
    return response;
  };

  static requestSetPasswordAndVerify = async (
    getUser: GetUser
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      REQUEST_SET_PASSWORD_AND_VERIFY_URL,
      {
        params: getUser,
      }
    );
    return response;
  };

  static requestEmailVerification = async (
    getUser: GetUser
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      REQUEST_EMAIL_VERIFICATION,
      {
        params: getUser,
      }
    );
    return response;
  };

  static verifyEmail = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      `${VERIFY_EMAIL_URL}/${userId}`
    );
    return response;
  };

  static updateAccount = async (editUser: EditUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_USER_URL, {
      ...editUser,
    });
    return response;
  };
}

export default Auth;
